module.exports = __webpack_public_path__ + "img/zimbabwe.3526099a.png";